export default __webpack_public_path__ + "media/images/theme/wordmark_light_backup-e62118474e6e998d4113d6e70614f180.png";